export const CHECKBOX_TEST_ID = {
    CHECK_BOX_INPUT: 'check-box-input',
    CHECK_BOX_WRAPPER: 'check-box-wrapper',
};
